import { JobClass } from './job-class.model';
import { JobCraft } from './job-craft.model';

export interface JobCraftClass {
  classes: JobClass[];
  crafts: JobCraft[];
}
